// @flow
import React from 'react';
import classNames from 'classnames';
import InstantBookIcon from '../InstantBookIcon/InstantBookIcon';

import type {IntlShape} from 'react-intl';
import type {PriceItemShape} from '../DualPrice/DualPrice';

const PriceItem = ({
    item,
    key,
    showInstantBookIcon,
    instantBookable,
    intl
}: {
    item: PriceItemShape,
    key?: string,
    showInstantBookIcon: boolean,
    instantBookable: boolean,
    intl: IntlShape
}) => {
    const {
        pricePeriodDescription,
        formattedAmount,
        roundedFormattedAmount,
        isPrimary
    } = item;
    const isInsantBookable =
        showInstantBookIcon && instantBookable && isPrimary;
    if (
        !pricePeriodDescription &&
        !formattedAmount &&
        !roundedFormattedAmount
    ) {
        return null;
    }

    const styleClass = classNames('', {
        DualPrice__primary: item.isPrimary,
        DualPrice__secondary: !item.isPrimary,
        'DualPrice__main-price': item.isPriceBold,
        DualPrice__withTooltip: item.withTooltip && formattedAmount
    });
    const stylePeriodClass = classNames('', {
        DualPrice__period: true,
        DualPrice__period_amount: !roundedFormattedAmount && !formattedAmount
    });

    return (
        <span key={key} className={styleClass}>
            {isInsantBookable && (
                <span className="DualPrice__instantBook_icon">
                    <InstantBookIcon intl={intl} />
                </span>
            )}
            <span className="DualPrice__amount">
                {roundedFormattedAmount || formattedAmount}
            </span>
            <span className={stylePeriodClass}>{pricePeriodDescription}</span>
        </span>
    );
};

export default PriceItem;
